import { module } from 'modujs';
import modularLoad from 'modularload';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const load = new modularLoad({
            enterDelay: 800,
            transitions: {
                size: {
                    enterDelay: 300,
                    exitDelay: 300
                }
            }
        });

        load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Menu')
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if(transition === 'size') {
                setTimeout(() => {
                    this.call('update', null, 'Scroll')
                },200)
            }
        });
    }
}
